@if (incident) {
	<div
		class="container"
		[attr.data-test]="'incident-item-' + incident.id"
		[class.unread]="incident.read === false"
		(click)="openSummary()"
	>
		<div class="item-content">
			<div class="header">
				<div class="title">
					<span>{{ locationDescription }}</span>
				</div>

				<i class="fa fa-external-link routing-icon"></i>
			</div>

			@if (incident.notes) {
				<blockquote>
					{{ incident.notes }}
				</blockquote>
			}

			<footer class="muted-footer">
				<span data-test="creation-info">
					<i class="fa fa-keyboard-o"></i>
					{{ incident.createdBy | name }}
				</span>

				<time data-test="planned-incident-date-and-time">
					<i class="fa fa-clock-o"></i>
					{{ incident.creationDate | date: "dd/MM HH:mm" }}
				</time>
			</footer>
		</div>
	</div>
}
